export default `
precision highp float;

attribute vec2 aVertexPosition;
attribute vec2 uv;
attribute vec3 normal;

//Pixi provided
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;

varying vec2 vUv;
varying vec3 vNormal;

void main() {
	vUv = uv;
	vNormal = normal;
	gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
}
`